"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanBoxGrid = PlanBoxGrid;
exports.default = PlanBoxSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _density = require("@site/pattern-library-utils/density");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _planBoxItem = _interopRequireDefault(require("../../../elements/other/plan-box-item"));
/** @module PlanBox */

const PlanBoxGridComponent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlanBoxGridComponent",
  class: "pl-p1egunoj",
  vars: {
    "p1egunoj-8": [({
      tabletColCount
    }) => `repeat(${tabletColCount}, minmax(0, 1fr))`],
    "p1egunoj-9": [({
      tabletRows
    }) => tabletRows],
    "p1egunoj-12": [({
      desktopColCount
    }) => `repeat(${desktopColCount}, minmax(0, 1fr))`],
    "p1egunoj-13": [({
      desktopRows
    }) => desktopRows],
    "p1egunoj-14": [({
      desktopColCount
    }) => {
      if (desktopColCount >= 3) {
        return `100%`;
      } else if (desktopColCount === 2) {
        return `60rem`;
      }
      return `30rem`;
    }]
  }
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hy3v2rq"
});
function createGridRows(rowCount) {
  let templateRows = ``;
  for (let i = 1; i <= rowCount; i++) {
    templateRows += `[fl-${i}] auto [im-${i}] auto [ts-${i}] auto [ds-${i}] auto [ps-${i}] auto [cs-${i}] auto [fls-${i}] auto `;
  }
  return templateRows;
}

/**
 * Render PlanBoxGrid Component
 *
 * @deprecated This component is deprecated. Please use SimplePlanBoxSection instead.
 * @param {Object} props React props
 * @param {Object} [props.items] item data
 * @returns {React.ReactElement} PlanBoxGrid element
 * @public
 */

function PlanBoxGrid({
  items
}) {
  const childCount = items?.length || 0,
    innerRowCount = 7;
  let desktopColCount = 2,
    tabletColCount = 2,
    desktopRowCount = 1,
    tabletRowCount = 1;
  if (childCount && childCount > 2) {
    if (childCount % 2 === 0) {
      desktopColCount = 4;
    } else if (childCount % 3 === 0) {
      desktopColCount = 3;
      tabletColCount = 1;
    }
  }
  if (childCount && childCount === 1) {
    desktopColCount = 1;
    tabletColCount = 1;
  }
  desktopRowCount = Math.ceil(childCount / desktopColCount);
  tabletRowCount = Math.ceil(childCount / tabletColCount);
  const tabletRows = createGridRows(tabletRowCount),
    desktopRows = createGridRows(desktopRowCount);
  return /*#__PURE__*/_react.default.createElement(PlanBoxGridComponent, {
    "data-cy": "plan-box-grid",
    tabletColCount: tabletColCount,
    tabletRows: tabletRows,
    desktopColCount: desktopColCount,
    desktopRows: desktopRows
  }, items?.map((item, i) => {
    const tabletRow = Math.ceil((i + 1) / tabletColCount),
      desktopRow = Math.ceil((i + 1) / desktopColCount);
    let tabletColumn = i + 1,
      desktopColumn = i + 1,
      tabletRowStart = tabletRow,
      tabletRowEnd = tabletRow + innerRowCount,
      desktopRowStart = desktopRow,
      desktopRowEnd = desktopRow + innerRowCount;
    if (tabletRow > 1) {
      tabletColumn -= (tabletRow - 1) * tabletColCount;
      tabletRowStart = (tabletRow - 1) * innerRowCount + 1;
      tabletRowEnd = tabletRowStart + innerRowCount;
    }
    if (desktopRow > 1) {
      desktopColumn -= (desktopRow - 1) * desktopColCount;
      desktopRowStart = (desktopRow - 1) * innerRowCount + 1;
      desktopRowEnd = desktopRowStart + innerRowCount;
    }
    return /*#__PURE__*/_react.default.createElement(_planBoxItem.default, (0, _extends2.default)({
      key: i,
      gridSettings: {
        tabletRow: tabletRow,
        tabletColumn: tabletColumn,
        tabletRowStart: tabletRowStart,
        tabletRowEnd: tabletRowEnd,
        desktopRow: desktopRow,
        desktopColumn: desktopColumn,
        desktopRowStart: desktopRowStart,
        desktopRowEnd: desktopRowEnd
      }
    }, item));
  }));
}
PlanBoxGrid.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_planBoxItem.default.propTypes))
};
const PlanboxGridContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlanboxGridContainer",
  class: "pl-p15gu3oz"
});

/**
 * Render PlanBox Component
 * @memberof module:PlanBox
 *
 * @param {Object} props React props
 * @param {Array} [items] Array of PlanBoxItem data
 * @param {String} props._name Tracking Name
 * @param {String} props.verticalMargin Vertical Layout Spacing Values
 * @returns {React.ReactElement} PlanBoxSection element
 * @public
 */

function PlanBoxSection({
  items,
  _name,
  verticalMargin,
  ...headlineProps
}) {
  const {
    heading,
    eyebrow
  } = headlineProps;
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "plan-box-section",
    verticalMargin: verticalMargin
  }, (heading || eyebrow) && /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, /*#__PURE__*/_react.default.createElement(_index.default, headlineProps)), /*#__PURE__*/_react.default.createElement(PlanboxGridContainer, null, items && /*#__PURE__*/_react.default.createElement(PlanBoxGrid, {
    items: items
  })));
}
PlanBoxSection.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_planBoxItem.default.propTypes)),
  _name: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};